(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luniora-customer-result-cards"] && !Shopify.designMode) return;
  try {
    
  class CustomerResultCards extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-result-cards-track]');
      this.cards = [...this.querySelectorAll('[data-result-card]')];
      this.currentIndex = 0;
      this.timer = null;
      this.isVisible = true;
      this.scrollFrame = null;

      if (!this.track || this.cards.length < 2) return;

      this.onScroll = () => {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateCurrentIndex());
      };

      this.onResize = () => {
        this.updateCurrentIndex();
        this.restart();
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('touchstart', () => this.stop(), { passive: true });
      this.addEventListener('touchend', () => this.restart(), { passive: true });
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      window.addEventListener('resize', this.onResize);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              this.start();
            } else {
              this.stop();
            }
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    canScroll() {
      return this.track.scrollWidth > this.track.clientWidth + 2;
    }

    updateCurrentIndex() {
      const trackLeft = this.track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.currentIndex = closestIndex;
    }

    goTo(index) {
      const safeIndex = Math.max(0, Math.min(this.cards.length - 1, index));
      const card = this.cards[safeIndex];
      if (!card) return;

      const left = card.offsetLeft - this.track.offsetLeft;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollTo({
        left,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
      this.currentIndex = safeIndex;
    }

    start() {
      if (
        this.dataset.autoplay !== 'true' ||
        !this.isVisible ||
        !this.canScroll() ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      this.stop();
      const interval = Number(this.dataset.interval) || 5000;

      this.timer = window.setInterval(() => {
        const nextIndex = this.currentIndex >= this.cards.length - 1 ? 0 : this.currentIndex + 1;
        this.goTo(nextIndex);
      }, interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('customer-result-cards')) {
    customElements.define('customer-result-cards', CustomerResultCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luniora-home-product-offer"] && !Shopify.designMode) return;
  try {
    
  class LunioraProductBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-bundle-submit]');
      this.status = this.querySelector('[data-bundle-status]');
      this.button?.addEventListener('click', () => this.addBundle());
    }

    async addBundle() {
      const selectors = [...this.querySelectorAll('[data-bundle-variant]')];
      const items = selectors.map((selector) => ({ id: Number(selector.value), quantity: 1 }));
      if (items.length !== 2 || items.some((item) => !item.id)) return;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Adding bundle…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('Unable to add this bundle.');
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        this.status.textContent = error.message;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('luniora-product-bundle')) {
    customElements.define('luniora-product-bundle', LunioraProductBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luniora-sale-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sale-offer-action]');
    if (!trigger) return;

    const action = trigger.dataset.saleOfferAction;
    const productArea =
      document.querySelector('product-information') ||
      document.querySelector('[data-product-information]') ||
      document.querySelector('.product-information');
    const addButton =
      productArea?.querySelector('button.add-to-cart-button:not([disabled])') ||
      document.querySelector('button.add-to-cart-button:not([disabled])');
    const purchaseArea =
      addButton?.closest('.product-form-buttons') ||
      productArea?.querySelector('.product-form-buttons') ||
      addButton;

    if (action === 'add_to_cart' && addButton) {
      addButton.click();
      return;
    }

    if (purchaseArea) {
      purchaseArea.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
